import { ContactTemp } from './contact-temp.model';
import { JsonProperty } from 'json-typescript-mapper/index';

export class MerchantChange extends ContactTemp {

  @JsonProperty('marketwebsiteId')
  public marketwebsiteId?: number;

  @JsonProperty('marketwebsitePublishedVersion')
  public marketwebsitePublishedVersion?: number;

  @JsonProperty('marketwebsiteVersion')
  public marketwebsiteVersion?: number;

  @JsonProperty('status')
  public status?;

  constructor() {
    super();
    this.marketwebsiteId = void 0;
    this.marketwebsitePublishedVersion = void 0;
    this.marketwebsiteVersion = void 0;
    this.status = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/merchant-change.model.ts